import { z } from "zod/v4";

import { AnalyticsProductDtoSchema } from "../../../dtos/analytics-products";
import { ExperienceProductDtoSchema } from "../../../dtos/experience-products";
import {
  ExperienceDto,
  ExperienceDtoSchema,
  InternalExperienceDtoSchema,
} from "../../../dtos/experiences";

export const GetExperienceRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type GetExperienceRequestPathParamType = z.infer<
  typeof GetExperienceRequestPathParamSchema
>;

export const GetExperienceResponseBodySchema = z.object({
  experience: ExperienceDtoSchema,
});

export type GetExperienceResponseBodyType = {
  experience: ExperienceDto;
};

export const InternalGetExperienceRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type InternalGetExperienceRequestPathParamType = z.infer<
  typeof InternalGetExperienceRequestPathParamSchema
>;

export const GetInternalExperienceResponseBodySchema = z.object({
  experience: InternalExperienceDtoSchema,
  priceProducts: z.array(ExperienceProductDtoSchema).optional(),
  analyticsProducts: z.array(AnalyticsProductDtoSchema).optional(),
  organization: z.object({
    name: z.string().nullish(),
    timezone: z.string().nullish(),
    shopId: z.string(),
  }),
  configuration: z.object({
    shipping_cost_per_order: z.number(),
    transaction_fee_pct: z.number(),
    max_z_score: z.number(),
    exclude_ip_addresses: z.array(z.string()),
    exclude_order_tags: z.array(z.string()),
    use_original_revenue: z.boolean(),
    is_headless_storefront: z.boolean(),
  }),
});

export type GetInternalExperienceResponseBodyType = z.infer<
  typeof GetInternalExperienceResponseBodySchema
>;
